let o = "undefined" != typeof window && window.console && window.console.error && window.console.error.bind(window.console);
"undefined" != typeof window && window.console && window.console.info && window.console.info.bind(window.console);
let n = "undefined" != typeof window && window.console && window.console.log && window.console.log.bind(window.console),
  w = "undefined" != typeof window && window.console && window.console.warn && window.console.warn.bind(window.console);
export { o as error, n as log, w as warn };
